import React from "react";
import { setPagination } from "utils/set_pagination";
import { isEmpty } from "utils/is_empty";
import styles from "styles/components/CustomPagination.module.css";

export default function CustomPagination({
  pagination,
  onChangePage,
  showData = true,
  center = false,
}) {
  if (!isEmpty(pagination)) {
    let dataNumberPagination = [];
    for (var i = 0; i < pagination.last_page; i++) {
      dataNumberPagination.push(i + 1);
    }
    let dataPaginationAfterFilter =
      dataNumberPagination.length >= 8
        ? setPagination(dataNumberPagination, pagination.current_page)
        : dataNumberPagination;
    return (
      <div
        className={
          !center ? styles.footerContainer : styles.footerContainerCenter
        }
      >
        {showData && (
          <p className={styles.showData}>
            Showing Data {pagination.from} to {pagination.to} of{" "}
            {pagination.totals}
          </p>
        )}
        {dataNumberPagination.length>1 ? (
        <button
          onClick={() =>
            pagination.current_page <= 1
              ? null
              : onChangePage(pagination.current_page - 1)
          }
          disabled={pagination.current_page <= 1}
          className={
            pagination.current_page <= 1
              ? styles.btnPaginationNotActive
              : styles.btnPagination
          }
          type="button"
        >
          Prev
        </button>
        ):""}
        
        {!isEmpty(dataPaginationAfterFilter && dataNumberPagination.length>1)
          ? dataPaginationAfterFilter.map((value, idx) => {
              if (value !== "") {
                return (
                  <button
                    key={idx}
                    onClick={() =>
                      value === pagination.current_page
                        ? null
                        : onChangePage(value)
                    }
                    className={
                      value === pagination.current_page
                        ? styles.btnPaginationNumberActive
                        : styles.btnPaginationNumber
                    }
                    type="button"
                  >
                    {value < 10 ? "0" + value : value}
                  </button>
                );
              } else if (value === "") {
                return (
                  <button
                    key={idx}
                    className={styles.btnPaginationNumber}
                    type="button"
                  >
                    ...
                  </button>
                );
              }
            })
          : null}

        {dataNumberPagination.length>1 ? (
        <button
          onClick={() =>
            !(pagination.last_page > pagination.current_page)
              ? null
              : onChangePage(pagination.current_page + 1)
          }
          disabled={!(pagination.last_page > pagination.current_page)}
          className={
            pagination.last_page > pagination.current_page
              ? styles.btnPagination
              : styles.btnPaginationNotActive
          }
          type="button"
        >
          Next
        </button>
        ):""} 
      </div>
    );
  } else {
    return <div className={styles.empty}>No have data pagination</div>;
  }
}
